

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function ComplexStatisticsCard4({ title, title1, title2, colorcount1, colorcount2, count1, count2 }) {
  return (
    <Card 
    style={{minWidth:"fit-content"}}
    >
      <MDBox display="flex" justifyContent="space-between" pt={1} px={2}>
        <MDBox textAlign="center" lineHeight={1.25}>
              <MDTypography variant="h6" fontWeight="medium" py={1} >
                {title}
              </MDTypography>
        </MDBox>
      </MDBox>
      
      <Divider />
      <MDBox pb={2} px={2} style={{ display: "flex", justifyContent: "space-evenly" }}>
        <MDBox textAlign="center" lineHeight={1.25}>
          <MDTypography style={{ color: colorcount1 ? colorcount1 : "#198038" }} variant="h5">{count1}</MDTypography>
          <MDTypography variant="button" fontWeight="light" color="text">
            {title1}
          </MDTypography>
        </MDBox>
        <Divider orientation="vertical" style={{ minHeight: "9vh", color: "rgba(0, 0, 0, 0.11)" }} flexItem />
        <MDBox textAlign="center" lineHeight={1.25}>
          <MDTypography style={{ color: colorcount2 ? colorcount2 : "#DA1E28" }} variant="h5">{count2}</MDTypography>
          <MDTypography variant="button" fontWeight="light" color="text">
            {title2}
          </MDTypography>
        </MDBox>
      </MDBox>
    </Card>
  );
}

// Setting default values for the props of ComplexStatisticsCard
ComplexStatisticsCard4.defaultProps = {
  color: "info",
  percentage: {
    color: "success",
    text: "",
    label: "",
  },
};

// Typechecking props for the ComplexStatisticsCard
ComplexStatisticsCard4.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
  title: PropTypes.string.isRequired,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  percentage: PropTypes.shape({
    color: PropTypes.oneOf([
      "primary",
      "secondary",
      "info",
      "success",
      "warning",
      "error",
      "dark",
      "white",
    ]),
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
  }),
  icon: PropTypes.node.isRequired,
};

export default ComplexStatisticsCard4;
